import {CalendarSquareRegularActivityIcon} from 'shells/icon/svg/calendar-square-regular-activity-icon';
import {CursorRegularIcon} from 'shells/icon/svg/cursor-regular-icon';
import {Stack} from 'shells/layout/stack/stack';
import {Modal} from 'shells/modal/modal';
import type {AvailabilityLevel} from 'shells/table/matrix-heatmap/types';
import {Body} from 'shells/typography/body';

import {formatLongDate} from '../helpers';

import {AvailabilityForecast} from './availability-forecast';
import {PerformanceCard} from './performance-card';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    dateData: DailyPerformanceSummaryDateData;
}

export type ForecastCell = {
    level: AvailabilityLevel;
    date: string;
};

export type DailyPerformanceSummaryDateData = {
    dateString: string;
    isBookable: boolean;
    numViews: number;
    numBookings: number;
    forecastCells: ForecastCell[];
};

export function DailyPerformanceSummaryModal(props: Props) {
    const formattedDay = formatLongDate(props.dateData.dateString);

    const hasForecast = props.dateData.forecastCells.length > 0;

    return (
        <Modal
            isOpen={props.isOpen}
            onClose={props.onClose}
            maxWidth={450}
            maxHeight={hasForecast ? 320 : 220}
            isCentered={true}
            noPadding={true}
        >
            <div className='pad-24'>
                <Stack spacing={24}>
                    <div>
                        <Stack isHorizontal={true} spacing={8} alignItems='center'>
                            <Body as='div' size='xlarge' color='dark' isBold={true}>
                                {formattedDay}
                            </Body>
                            <Body color='light'>
                                {props.dateData.isBookable
                                    ? '(Bookable day)'
                                    : '(Non-bookable day)'}
                            </Body>
                        </Stack>
                        <Body color='light'>Daily performance summary</Body>
                    </div>
                    <Stack spacing={12} isHorizontal={true}>
                        <div className='half-width'>
                            <PerformanceCard
                                title='Views'
                                value={props.dateData.numViews.toLocaleString()}
                                icon={CursorRegularIcon}
                            />
                        </div>
                        <div className='half-width'>
                            <PerformanceCard
                                title='Bookings created'
                                value={props.dateData.numBookings.toLocaleString()}
                                icon={CalendarSquareRegularActivityIcon}
                            />
                        </div>
                    </Stack>
                    {hasForecast && (
                        <AvailabilityForecast forecastCells={props.dateData.forecastCells} />
                    )}
                </Stack>
            </div>
        </Modal>
    );
}
